'use client';

import { useEffect } from 'react';
import { conversionTypeFromHref, trackSiteEvent, vehicleIdFromPathname } from '@/lib/track-site-event';

/**
 * Registra en `site_events` los clics de conversión que hoy no quedaban en
 * ningún lado: WhatsApp (`whatsapp_click`) y Llamar (`call_click`).
 *
 * Un solo listener global en fase de CAPTURA sobre `document`: cubre todo
 * `<a href>` del sitio (FloatingWhatsApp, footers, ContactCTA, HowToArrive,
 * SocialLinks, ficha del vehículo…) sin tocar cada componente y sin depender de
 * que el handler del componente no haga stopPropagation.
 *
 * Los botones que abren WhatsApp/tel SIN `<a>` (window.open / location.href)
 * llaman explícitamente a `trackConversionFromHref` — ver track-site-event.ts.
 */
export function SiteEventTracker() {
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      try {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const anchor = target.closest('a[href]');
        if (!anchor) return;
        const href = anchor.getAttribute('href') || '';
        const eventType = conversionTypeFromHref(href);
        if (!eventType) return;
        // Nunca bloquear: el insert corre solo, la navegación sigue.
        void trackSiteEvent(eventType, {
          vehicleId: vehicleIdFromPathname(),
          metadata: { href, source: 'anchor' },
        });
      } catch (error) {
        console.error('SiteEventTracker:', error);
      }
    };

    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  return null;
}
